// Mock data for Genius Education Centre

export const programs = [
  { id: 1, name: "Pra Sekolah / PAUD", icon: "Baby", description: "Program persiapan sekolah untuk anak usia dini" },
  { id: 2, name: "Membaca, Menulis, & Berhitung", icon: "BookOpen", description: "Fondasi dasar literasi dan numerasi" },
  { id: 3, name: "Bahasa Inggris", icon: "Languages", description: "Penguasaan bahasa internasional" },
  { id: 4, name: "Bahasa Mandarin", icon: "Globe", description: "Belajar bahasa Mandarin dari dasar" },
  { id: 5, name: "Matematika & IPA", icon: "Calculator", description: "Penguatan konsep matematika dan sains" },
  { id: 6, name: "IPAS", icon: "Lightbulb", description: "Ilmu Pengetahuan Alam dan Sosial" },
  { id: 7, name: "TOEFL Preparation", icon: "GraduationCap", description: "Persiapan tes TOEFL internasional" },
  { id: 8, name: "Program Profesi 1 Tahun", icon: "Award", description: "Program intensif profesi selama 1 tahun" }
];

export const classOptions = [
  { id: 1, name: "Kelas Privat", icon: "User", description: "Pembelajaran satu-satu dengan tutor" },
  { id: 2, name: "Privat Group", icon: "Users", description: "Belajar dalam kelompok kecil" },
  { id: 3, name: "Kelas Regular", icon: "School", description: "Kelas dengan jadwal tetap" },
  { id: 4, name: "Kelas Online", icon: "Monitor", description: "Belajar dari rumah secara online" }
];

export const branches = [
  { id: 1, name: "Genius Adipati", phone: "0813 4922 5525", address: "Jl. Adipati, Kota" },
  { id: 2, name: "Genius Ahmad Yani", phone: "0878 1271 3780", address: "Jl. Ahmad Yani, Kota" },
  { id: 3, name: "Genius Iskandar", phone: "0815 2852 7487", phoneAlt: "0895 6013 62828", address: "Jl. Iskandar, Kota" }
];

export const educationLevels = [
  { id: 1, name: "PAUD", age: "3-4 tahun" },
  { id: 2, name: "TK", age: "5-6 tahun" },
  { id: 3, name: "SD", age: "7-12 tahun" },
  { id: 4, name: "SMP", age: "13-15 tahun" },
  { id: 5, name: "SMA", age: "16-18 tahun" },
  { id: 6, name: "Umum", age: "Semua usia" }
];

export const advantages = [
  { id: 1, name: "Free Wifi", icon: "Wifi", description: "Akses internet gratis untuk mendukung pembelajaran" },
  { id: 2, name: "Tutor Profesional", icon: "UserCheck", description: "Pengajar berpengalaman dan tersertifikasi" },
  { id: 3, name: "Ruang Kelas Nyaman", icon: "Home", description: "Fasilitas belajar yang modern dan nyaman" },
  { id: 4, name: "Melayani Konsultasi", icon: "MessageCircle", description: "Konsultasi gratis untuk kebutuhan belajar" }
];

export const testimonials = [
  {
    id: 1,
    name: "Ibu Sari",
    role: "Orang Tua Siswa",
    text: "Anak saya sangat berkembang setelah belajar di Genius. Nilai matematikanya meningkat drastis!",
    rating: 5
  },
  {
    id: 2,
    name: "Budi Santoso",
    role: "Siswa SMA",
    text: "Tutornya ramah dan sabar. Metode mengajarnya mudah dipahami. Sangat recommended!",
    rating: 5
  },
  {
    id: 3,
    name: "Ibu Dewi",
    role: "Orang Tua Siswa",
    text: "Fasilitas lengkap dan lokasi strategis. Anak-anak saya senang belajar di sini.",
    rating: 5
  }
];

export const stats = [
  { id: 1, value: "1000+", label: "Siswa Aktif" },
  { id: 2, value: "50+", label: "Tutor Profesional" },
  { id: 3, value: "3", label: "Cabang" },
  { id: 4, value: "15+", label: "Tahun Pengalaman" }
];

export const images = {
  students1: "https://images.unsplash.com/photo-1624731556141-847f6d44e0c7?w=800&q=80",
  students2: "https://images.pexels.com/photos/11257302/pexels-photo-11257302.jpeg?w=800",
  students3: "https://images.pexels.com/photos/12719298/pexels-photo-12719298.jpeg?w=800",
  teaching: "https://images.unsplash.com/photo-1577896851231-70ef18881754?w=800&q=80",
  classroom: "https://images.unsplash.com/photo-1573894999291-f440466112cc?w=800&q=80",
  classroom2: "https://images.pexels.com/photos/35113868/pexels-photo-35113868.jpeg?w=800",
  modernLearning: "https://images.unsplash.com/photo-1565598621680-94ac0c22b148?w=800&q=80",
  collaboration: "https://images.unsplash.com/photo-1531545514256-b1400bc00f31?w=800&q=80"
};
